import { entries } from "../../utils/entries.js";
import { Country } from "../Country.js";
import { Currency } from "../Currency.js";
import type { Customer } from "../Customer.js";
import { CustomerType } from "../CustomerType.js";
import { PaymentType } from "../PaymentType.js";
import { getCustomerType } from "./getCustomerType.js";

function filter(paymentType: PaymentType, deliveryCountry: Country, currency: Currency): boolean {
	if (paymentType === PaymentType.OnDelivery) {
		return deliveryCountry === Country.Czechia && currency === Currency.CZK;
	}
	return true;
}

// Order matters
const paymentTypes: Record<CustomerType, Record<PaymentType, boolean | ((customer: Customer | null) => boolean)>> = {
	[CustomerType.B2c]: {
		[PaymentType.OnInvoice]: false,
		[PaymentType.Subscription]: false,
		[PaymentType.WithoutInvoice]: false,
		[PaymentType.GoPayApplePay]: true,
		[PaymentType.GoPayQRCode]: true,
		[PaymentType.GoPayPaymentCard]: true,
		[PaymentType.GoPayGPay]: true,
		[PaymentType.OnDelivery]: true,
	},
	[CustomerType.B2b]: {
		[PaymentType.OnInvoice]: (customer) => customer?.allowPaymentOnInvoice === true,
		[PaymentType.Subscription]: false,
		[PaymentType.WithoutInvoice]: false,
		[PaymentType.GoPayQRCode]: true,
		[PaymentType.OnDelivery]: true,
		[PaymentType.GoPayPaymentCard]: true,
		[PaymentType.GoPayApplePay]: true,
		[PaymentType.GoPayGPay]: true,
	},
	[CustomerType.B2f]: {
		[PaymentType.OnInvoice]: (customer) => customer?.allowPaymentOnInvoice === true,
		[PaymentType.Subscription]: false,
		[PaymentType.WithoutInvoice]: true,
		[PaymentType.GoPayQRCode]: true,
		[PaymentType.OnDelivery]: true,
		[PaymentType.GoPayPaymentCard]: true,
		[PaymentType.GoPayApplePay]: true,
		[PaymentType.GoPayGPay]: true,
	},
};

export function getSortedPaymentTypesForCustomer(
	customer: Customer | null,
	country: Country,
	currency: Currency,
): PaymentType[] {
	const customerType = getCustomerType(customer);
	return entries(paymentTypes[customerType]).reduce<PaymentType[]>((previous, [key, value]) => {
		if (typeof value === "boolean" ? value : value(customer as never)) {
			if (filter(key, country, currency)) {
				return [...previous, key];
			}
		}
		return previous;
	}, []);
}
